import { render } from "./ContactBody.vue?vue&type=template&id=e42f51fc"
import script from "./ContactBody.vue?vue&type=script&lang=js"
export * from "./ContactBody.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__